// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"iV","skip_info":"jV","skipped":"kV","modify_order":"lV","cancel_subscription_btn":"mV","byb":"nV","modify_order_outer":"oV","byb_edit_btn":"pV","modify_order_item":"qV","cancel_copy_wrapper":"rV","cancelled_copy":"sV"};
    if(module.hot) {
      // 1711717534604
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  